import * as React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { Dictionary } from 'lodash';
import {
   DevicePickerContextType,
   DevicePickerProps,
   Hierarchy,
   State,
} from './types';
import findAllLeaves from './utils/findAllLeaves';

const devicePickerContextDefaults: DevicePickerContextType = {
   state: 'category',
   query: '',
   category: '',
   leaves: null,
   setState: () => {},
   setQuery: () => {},
   setCategory: () => {},
};

export const DevicePickerContext = createContext<DevicePickerContextType>(
   devicePickerContextDefaults,
);
export const useDevicePickerContext = () => useContext(DevicePickerContext);

export const withDevicePickerContext = (Component: any) => {
   return function withDevicePickerContextComponent(props: DevicePickerProps) {
      const [state, setState] = useState<State>('category');
      const [query, setQuery] = useState<string>('');
      const [category, setCategory] = useState<string>('');
      const [hierarchy, setHierarchy] = useState<Hierarchy>();
      const [displayTitles, setDisplayTitles] = useState<Dictionary<string>>();
      const [leaves, setLeaves] = useState<Set<string> | null>(null);

      const devicePickerContext: DevicePickerContextType = {
         state,
         query,
         category,
         hierarchy,
         displayTitles,
         leaves,
         setState,
         setQuery,
         setCategory,
      };

      useEffect(() => {
         props
            .fetchHierarchy()
            .then((json) => {
               setHierarchy(json.hierarchy);
               setDisplayTitles(json.display_titles);
               setLeaves(
                  findAllLeaves(
                     json.hierarchy,
                     json.display_titles,
                     new Set<string>(),
                  ),
               );
            })
            .catch((reason) => {
               throw reason;
            });
      }, []);

      return (
         <DevicePickerContext.Provider value={devicePickerContext}>
            <Component {...props} />
         </DevicePickerContext.Provider>
      );
   };
};
